import { executiveClient } from './executiveApi'
import type { MonitoringDashboard, MonitoredServer, TimeRange } from '../types/monitoring'

// Reuses the same axios instance as executiveApi (same base URL, same
// ExecutiveBearer interceptor, same 401/403 -> logout handling) — no
// separate auth path for monitoring.
export const monitoringAPI = {
  getServers: () =>
    executiveClient.get<{ servers: MonitoredServer[] }>('/monitoring/servers/'),
  getDashboard: (serverId: string, range: TimeRange) =>
    executiveClient.get<MonitoringDashboard>('/monitoring/dashboard/', {
      params: { server_id: serverId, range },
    }),
}
